<template>
	<v-app>
		<template v-if="$myStore.state.loggedIn">
			<v-navigation-drawer :width="220" app class="main-menu" clipped dark fixed v-model="drawer">
				<v-layout column fill-height>
				<v-list dense>
					<v-list-tile :to="{path: '/partners'}">
						<v-list-tile-action>
							<v-icon small>fa-user-tie</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.partners') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/contacts'}">
						<v-list-tile-action>
							<v-icon small>fa-address-book</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.contacts') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/opportunities'}">
						<v-list-tile-action>
							<v-icon small>fa-handshake</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.opportunities') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/locations'}">
						<v-list-tile-action>
							<v-icon small>fa-map-marker-alt</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.locations') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/languages'}">
						<v-list-tile-action>
							<v-icon small>fa-globe</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.languages') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/automatic-portals'}">
						<v-list-tile-action>
							<v-icon small>fa-atlas</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.automaticPortals') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/manual-portals'}">
						<v-list-tile-action>
							<v-icon small>fa-atlas</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.manualPortals') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/history'}">
						<v-list-tile-action>
							<v-icon small>fa-history</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.history') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/reports'}">
						<v-list-tile-action>
							<v-icon small>fa-table</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.reports') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile :to="{path: '/codebooks'}">
						<v-list-tile-action>
							<v-icon small>fa-book-open</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.codebooks') }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
					<v-spacer></v-spacer>
				<v-list>
					<v-list-tile @click="updateDB" :two-line="true">
						<v-list-tile-action>
							<v-icon small>fa-database</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ $t('modules.syncDatabase') }}</v-list-tile-title>
							<span style="font-size:11px;">{{ $t('modules.lastSync') }}: {{latestUpdateTime}}</span>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
				</v-layout>
			</v-navigation-drawer>
			<v-toolbar app clipped-left fixed>
				<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
				<v-breadcrumbs :items="$myStore.state.breadcrumbs" divider=">"></v-breadcrumbs>
				<v-spacer></v-spacer>
				{{ $myStore.state.user.first_name }} {{ $myStore.state.user.last_name }}
			</v-toolbar>
		</template>
		<v-content v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view :key="$route.fullPath"></router-view>
			</transition>
		</v-content>
	</v-app>
</template>

<script>

export default {
	name: 'Admin',
	components: {},
	data() {
		return {
			drawer: null,
			initialLoadCompleted: false,
			breadcrumbs: [],
			latestUpdateTime: null
		}
	},
	computed: {},
	watch: {},
	methods: {
		updateDB(){
			let vm = this;
			this.$verify((this.$t('alerts.updateDatabaseConfirmation1') + '<br>' + this.$t('alerts.updateDatabaseConfirmation2')), (result) => {
				if (result) {
					vm.$APICall('post', 'sync-all', {}, (data, success) => {
					if (success) {
						this.$router.go();
					}
					else{
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
				}
			});
		}
	},
	mounted() {
		let vm = this;
		this.$VtigerGetSession((success) => {
			if (success) {
				vm.initialLoadCompleted = true;
				vm.$APICall('get', 'latest-update-time', {}, (data, success2) => {
					if (success2) {
						if(data != null && data != undefined && Object.keys(data).length !== 0){
							vm.latestUpdateTime = data;
						}
						else{
							vm.latestUpdateTime = 'n/a';
						}
					}
					else{
						vm.latestUpdateTime = 'n/a';
					}
				});
			}
		});
	}
}
</script>

<style scoped>
>>> .v-breadcrumbs__item {
	font-weight: bold;
}

>>> .v-breadcrumbs__item--disabled {
	font-weight: bold;
	color: #000000 !important;
}
</style>
